<template>
  <div class="indexToolList">
       <a-spin :spinning="spinning" size="large" tip="加载中...">
        <div class="reply" ref = 'replayModal'>
        <a-modal
            v-model:visible="addVisible"
            destroyOnClose="true"
            :title="title"
            @ok="handleOk"
            width="60%"
            :afterClose="afterClose"
             :getContainer = '()=>$refs.replayModal'
             wrapClassName="full-modal"
            >
            <a-form
                ref="formRef"
                :model="formState"
                :rules="rules"
            >
                <a-form-item  label="组合名称" name="keyName">
                    <a-input placeholder="请输入组合名称" v-model:value="formState.keyName" />
                </a-form-item>
                <!-- <a-form-item label="关注声量" name="keyNum">
                    <a-input placeholder="请输入关注声量" v-model:value="formState.keyNum" />
                </a-form-item>
                <a-form-item  label="接收邮箱" name="keyEmail">
                    <a-input placeholder="请输入接收邮箱" v-model:value="formState.keyEmail" />
                </a-form-item> -->
              </a-form>
            <a-transfer
                :data-source="mockData"
                show-search
                 :filter-option="(inputValue, item) => item.title.toLowerCase().indexOf(inputValue.toLowerCase()) !== -1"
                :target-keys="targetKeys"
                :render="item => item.title"
                @change="handleChange"
            >
          <template
            #children="{
            direction,
            filteredItems,
            selectedKeys,
            onItemSelectAll,
            onItemSelect,
            }"
        >
        <a-table
        :row-selection="getRowSelection({  selectedKeys, onItemSelectAll, onItemSelect })"
          :columns="direction === 'left' ? leftColumns : rightColumns"
        :data-source="filteredItems"
           size="small"
        >
            <a-pagination :total="50" show-less-items />
        </a-table>
      </template>
            </a-transfer>
        </a-modal>
        </div>
        <indexHeader></indexHeader>
        <div class="tool">
            <!-- <img class="bg" src="../../assets/image/bg12.png" alt=""> -->
            <div class="title">社媒指数</div>
            <!-- <a-input-search
            v-model:value="searchVal"
            placeholder="请输入搜索字词"
            enter-button="搜索"
            @search="onSearch"
            /> -->
            <div class="btn-wrapper">
                <!-- <a-mentions autofocus  :prefix="['@','']" v-model:value="searchVal" @select="onSelect">
                    <a-mentions-option :value="i.keyword" v-for="i in searchList" :key="i">
                             {{i.keyword}}
                    </a-mentions-option>
                </a-mentions> -->
                <a-auto-complete
                    @search="handleSearch1"
                    @select="onSelect"
                    @dropdownVisibleChange="dropdownVisibleChange"
                >
                <template #default>
                    <a-input
                        placeholder="请输入搜索字词"
                        v-model:value="searchVal"
                        @pressEnter.prev = "foucusFun"
                        /> 
                </template>
                <template #dataSource>
                    <a-select-option v-for="i in searchList" :key="i.keyword">
                       {{i.keyword}}
                    </a-select-option>
                </template>
                </a-auto-complete>
                  <a-button type="primary" @click="onSearch" class="search">搜索</a-button>
            </div>
            
            <!-- <a-select  v-model:value="searchVal"  show-search style="width: 200px">
                <a-select-option v-for="i in searchList" :key="i">
                    {{i.keyword}}
                </a-select-option>
            </a-select> -->
            <div class="subTitle">热词搜索</div>
            <div class="dataList">
                <div class="list" v-for="list in hotWordList" :key="list.id" @click="turnPath(list)">{{list}}</div>
                <!-- <div class="list">Keyword2</div>
                <div class="list">Keyword3</div> -->
            </div>
        </div>
        <div class="hasData" v-if="hasData">
            <a-tabs v-model:activeKey="activeKey">
                <a-tab-pane key="1" tab="关注">
                     <a-table bordered @change="handleTableChange"  :pagination="{
                        current: focusCurrent,
                        showSizeChanger: true,
                        showQuickJumper: true,
                        pageSizeOptions: ['10', '20', '50', '100'],
                        total: focusTotal,
                        onChange: changePage,
                     }" :customRow="rowClick" :dataSource="dataKeySource"  :columns="keyColumns" >
                        <!-- <template #wechat="{ record }"> -->
                            <!-- {{ record.wechat }} 
                            <img v-if="record.wechatup>0" class="tip" src="../../assets/image/up.png">
                            <img v-else class="tip" src="../../assets/image/down.png">
                        </template>
                       <template #bdzs="{ record }">
                            {{ record.bdzs }} 
                            <img v-if="record.bdzsup>0" class="tip" src="../../assets/image/up.png">
                            <img v-else class="tip" src="../../assets/image/down.png">
                        </template>
                        <template #weibo="{ record }">
                              {{ record.weibo }} 
                            <img v-if="record.weiboup>0" class="tip" src="../../assets/image/up.png">
                            <img v-else class="tip" src="../../assets/image/down.png">
                        </template> -->
                        <!-- <template #age="{ text }">
                            {{ text }} <img class="tip" src="../../assets/image/down.png">
                        </template> -->
                        <template #operation="{ record }">
                            <a class="link"  @click.stop="showModal(record.keywordFollowId)">取消关注</a>
                        </template>
                     </a-table>
                      <!-- <a-pagination show-size-changer show-quick-jumper
                        v-model:current="focusCurrent"
                        v-model:pageSize="focusPageSize"
                        @change="changeData"  @showSizeChange="onShowSizeChange" :total="focusTotal" /> -->
                </a-tab-pane>
                <a-tab-pane key="2" tab="组合" force-render>
                    <div class="listContain">
                        <div class="list first" @click="addOne">
                            +新建组合
                        </div>
                        <div class="list" @click="turnDetail(list.keywords,list.groupName,list.id)" v-for="list in hotWord" :key="list.id">
                            <img src="@/assets/image/bg11.png" alt="">
                            <div class="right">
                                <div class="right1">{{list.groupName}}</div>
                                <div class="right2">包含关键词</div>
                                <div class="right3">
                                    <div class="right-list"  v-for="list1 in list.keywords.split(',')" :key="list1">{{list1}}</div>
                                    <div style="clear:both"></div>
                                    <!-- <div class="right-list">keyWord2</div>
                                    <div class="right-list">keyWord3</div> -->
                                </div>
                            </div>
                            <div class="btnContain">
                                <div class="edit" @click.stop="add(list.id,list.groupName)">编辑</div>
                                <div class="delete" @click.stop="delte(list.id)">删除</div>
                            </div>
                        </div>
                        <div style="clear:both"></div>
                    </div>
                </a-tab-pane>
            </a-tabs>
        </div>
       </a-spin>
       <div class="hoverBottomWapper">
            <div  class="beian">
                <a  style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img src="../../assets/beian.png" style="float:left;"/>
                <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;"><a href="http://www.beian.gov.cn/" target="_blank">粤公网安备 44011202001572号</a> | <a href="https://beian.miit.gov.cn" target="_blank" >粤ICP备2021056281号</a> </p ></a>
            </div>
       </div>
      
  </div>
</template>

<script>
import indexHeader from '@/components/indexHeader'
import {Modal,message} from 'ant-design-vue'
import { cloneDeep } from "lodash-es";
import { difference } from 'lodash-es';
import {  h } from 'vue';
import { CloseOutlined,PlusOutlined } from "@ant-design/icons-vue";
import { getIndexList,getHotkeyList,getTopIndex,getInfoList,addHotkeyList,getWordList,removeHotKey,getDetailByid,getWordListIndex,removeWordListIndex,getAllWordList,editAllWordList } from '../../utils/api'
const checkEmail = function(rule,val){
  if(/^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/.test(val)){
    return Promise.resolve();
  }else{
    return Promise.reject('邮箱格式不正确');
  }
}
export default {
    components:{
        indexHeader,
        CloseOutlined,
        PlusOutlined
    },
    mounted(){
        let that = this;
        this.getIndex()
        this.getHotkey()
        this.getWordList()
        getInfoList().then(res=>{
            that.selectColumns = res.rows
            res.rows.map((cur,index)=>{
                that.keyColumns.push({
                    title:  cur.name,
                    dataIndex:  cur.name,
                    align:'right',
                    customRender: ({ text, record,index }) => {
                        if(record[cur.name+'增量']>0){
                            return [h("span", that.formatNum(text)), h('img', { src: that.img1,class:'tip' })];
                        }else if(record[cur.name+'增量']<0){
                            return [h("span", that.formatNum(text)), h('img', { src: that.img2,class:'tip' })];
                        }else{
                            return [h("span", that.formatNum(text))];
                        }
                    },
                    sorter: true,
                    key:  cur.name,
                    // title: cur.name,
                    // dataIndex:  cur.name,
                    // sorter: true,
                    // align: 'right',
                    // key: cur.name,
                    // customRender: ({ text, index }) => {
                    //     return that.formatNum(text)
                    // },
                })
            })
            that.keyColumns.push(  {
                title: "操作",
                dataIndex: "operation",
                 align:'right',
                slots: {
                customRender: "operation",
                },
            })
        })
    },
    data(){
        return{
            showDrop:false,
            img1:require('../../assets/image/up.png'),
            img2:require('../../assets/image/down.png'),
            spinning:true,
            leftColumns:[{
                dataIndex: 'title',
                title: '关键词',
            }],
            rightColumns:[{
                dataIndex: 'title',
                title: '关键词',
            }],
            mockData:[],
            searchList:[],
            focusCurrent:1,
            focusPageSize:10,
            focusTotal:0,
            title:'添加组合',
            searchVal:'',
            formState:{
                keyName:'',
                keyNum:'',
                keyEmail:''
            },
            rules:{
                keyName: [
                    { required: true, message: '请输入组合名称', trigger: 'blur' },
                ],
                keyNum: [
                    { required: true, message: '请输入关注声量', trigger: 'blur' },
                ],
                keyEmail: [
                    { required: true, message: '请输入接收邮箱', trigger: 'blur' },
                    { validator: checkEmail, message: '邮箱格式不正确', trigger: 'blur' }
                ]
            },
            addVisible:false,
            hotWord:[],
            currentIndex:'',
            hotWordList:[],
            dataList:[{id:0,name:'关键词1'},{id:1,name:'关键词2'}],
            hasData:true,
            value:'',
            currentNum:1,
            activeKey:"1",
            defaultData:[],
            targetKeys:[],
            groupId:'',
            editType:0,
            dataKeySource: [],
            // ipagination: {
            //     current: 1,
            //     pageSize: 10,
            //     onChange: this.changePage,
            //     total: this.focusTotal,
            //     showSizeChanger: true,
            //     showQuickJumper: true,
            //     pageSizeOptions: ['10','20','30'],  //这里注意只能是字符串，不能是数字
            // },
        keyColumns: [
          {
            title: '关键词',
            dataIndex: 'keyword',
             sorter: (a, b) => a.keyword.localeCompare(b.keyword),
            key: 'keyword',
          },
        //   {
        //     title: '百度指数',
        //     dataIndex: 'bdzs',
        //     align:'right',
        //       slots: {
        //         customRender: "bdzs",
        //     },
        //     sorter: true,
        //     key: 'bdzs',
        //   },
        //   {
        //     title: '微信指数',
        //     dataIndex: 'wechat',
        //     align:'right',
        //     slots: {
        //         customRender: "wechat",
        //     },
        //     sorter: true,
        //     key: 'wechat',
        //   },
        //   {
        //     title: '微博指数',
        //     dataIndex: 'weibo',
        //       slots: {
        //         customRender: "weibo",
        //     },
        //     sorter: true,
        //     align:'right',
        //     key: 'weibo',
        //   },
        //     {
        //     title: '社媒声望',
        //     dataIndex: 'age',
        //     align:'right',
        //     slots: {
        //         customRender: "age",
        //     },
        //      sorter: (a, b) => a.age.localeCompare(b.age),
        //     key: 'age',
        //   },
            // {
            //     title: "操作",
            //     dataIndex: "operation",
            //      align:'right',
            //     slots: {
            //     customRender: "operation",
            //     },
            // },
        ],
        }
    },
    methods:{
         getRowSelection({ selectedKeys, onItemSelectAll, onItemSelect }) {
      return {
        // getCheckboxProps: item => ({ props: { disabled: disabled || item.disabled } }),
        onSelectAll(selected, selectedRows) {
          const treeSelectedKeys = selectedRows
            .map(({ key }) => key);
          const diffKeys = selected
            ? difference(treeSelectedKeys, selectedKeys)
            : difference(selectedKeys, treeSelectedKeys);
          onItemSelectAll(diffKeys, selected);
        },
        onSelect({ key }, selected) {
          onItemSelect(key, selected);
        },
        selectedRowKeys: selectedKeys,
      }},
        onSelect(el){
            this.searchVal = el
        },
        dropdownVisibleChange(e){
            this.showDrop = e
        },
        handleSearch(dir, val){
            let that = this;
            that.mockData = []
            if(val==''){
                that.mockData = that.defaultData
                return
            }
            getAllWordList(val.toLowerCase()).then(res=>{
                res.rows.map((cur,index)=>{
                    that.mockData.push({
                        key: index,
                        title: cur.keyword,
                        chosen: false,
                    })
                })
            })
        },
        handleSearch1(){
            let that = this;
            if(this.searchVal==''){
                return;
            }
            getAllWordList(this.searchVal).then(res=>{
                if(res.total!=0){
                    that.searchList = res.rows
                }else{
                    that.searchList = []
                }
            })
        },
        foucusFun(){
            let that = this;
            let str = that.searchVal
            if(!this.showDrop){
                this.onSearch()
            }
        },
        changePage(page){
            this.focusCurrent = page
        },
        filterOption(input, option) {
            return option.title.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        },
        newSort (x, y) {
            return parseInt(x[this.currentIndex].toString().replace(/,/g, "")) - parseInt(y[this.currentIndex].toString().replace(/,/g, ""))
        },
        newSort1 (x, y) {
            return parseInt(y[this.currentIndex].toString().replace(/,/g, "")) - parseInt(x[this.currentIndex].toString().replace(/,/g, ""))
        },
        handleTableChange (pagination, filters, {field, order}) {
            this.currentIndex = field
            if(order=='descend'){
                this.dataKeySource.sort(this.newSort)
            }else{
                this.dataKeySource.sort(this.newSort1)
            }
        },
         onShowSizeChange(pageNo,pageSize){
            this.pageNo = pageNo
            this.pageSize = pageSize
            this.getWordList();
        },
        changeData(pageNo,pageSize){
            this.pageNo = pageNo
            this.pageSize = pageSize
            this.getWordList();
        },
         rowClick(record, index) {
            let that = this;
            return {
                onClick: (event) => {
                    that.$router.push({
                        name:'indexTool',
                        query:{
                            word:record.keyword,
                            type:0
                        }
                    })
                   //Do something
                },
            };
        },
        afterClose(){
            let that = this
            that.targetKeys = []
            that.formState.keyName = ''
            that.mockData = that.defaultData
        },
        turnDetail(word,group,id){
            this.$router.push({
                name:"indexGroupTool",
                query:{
                    word: word,
                    type:1,
                    groupName:group,
                    id:id
                }
            })
        },
        async getWordList(){
            let that = this;
            that.spinning = true;
            that.dataKeySource = []
              await getWordListIndex({pageNo:that.focusCurrent,pageSize:500}).then(res=>{
                  that.spinning = false;
                   if(res.total!=0){
                    that.dataKeySource = res.rows
                    that.focusTotal = res.total
                    // res.rows.map((cur)=>{
                    //     if(cur){
                    //         that.dataKeySource.push({
                    //             keyword:cur.keyword,
                    //             id:cur.keywordFollowId,
                    //             wechat: cur['微信指数']?that.formatNum(cur['微信指数']):'0',
                    //             wechatup:cur['微信指数增量']?cur['微信指数增量']:'0',
                    //             bdzs:cur['百度指数']?that.formatNum(cur['百度指数']):'0',
                    //             bdzsup:cur['百度指数增量']?cur['百度指数增量']:'0',
                    //             weibo:cur['微博指数']?that.formatNum(cur['微博指数']):'0',
                    //             weiboup:cur['微博指数增量']?cur['微博指数增量']:'0',
                    //         })
                    //     }
                    // })
                   }else{
                       that.dataKeySource = []
                   }
              })
        },
        turnPath(word){
            this.$router.push({
                name:'indexTool',
                query:{
                    word:word,
                    type:0
                }
            })
        },
        async getIndex(){
            let that = this
            await getTopIndex().then(res=>{
                if(res.total!=0){
                    res.rows.map((cur,index)=>{
                        if(index<5){
                            that.hotWordList.push(cur.keyword)
                        }
                    })
                }
            })
            await getAllWordList().then(res=>{
                if(res.total!=0){
                    res.rows.map((cur,index)=>{
                        that.defaultData.push({
                            key:index,
                            title:cur.keyword,
                            chosen:false
                        })
                        that.mockData.push({
                            key:index,
                            title:cur.keyword,
                            chosen:false
                        })
                    })
                    console.log(that.mockData)
                }else{
                    that.hotWord = []
                }
            })
        },
        handleChange(key,val){
            if(key.length>5){
                message.info('最多选择5个关键词')
                return
            }
            this.targetKeys = key.sort()
        },
        showModal(id){
            let that = this;
             Modal.confirm({
                title: '确认取消关注么?',
                onOk() {
                    removeWordListIndex(id).then(res=>{
                        message.success('取消成功！')
                        that.focusCurrent = 1;
                        that.getWordList()
                    })
                },
                onCancel() {
                },
            });
        },
        handleOk(){
            let that = this
            this.$refs.formRef
            .validate()
            .then(() => {
                if(that.targetKeys.length==0){
                    message.error('请选择关键词')
                    return
                }
                if(this.targetKeys.length>5){
                    message.info('最多选择5个关键词')
                    return
                }
                let str1 = ''
                that.targetKeys.map((cur)=>{
                    str1=str1+that.mockData[cur].title+','
                })  
                str1 = str1.substring(0,str1.length-1)
                if(this.editType==0){
                    addHotkeyList({keywords:str1,receiveEmail:that.formState.keyEmail,followPoint:that.formState.keyNum,groupName:that.formState.keyName}).then(res=>{
                        that.addVisible = false
                        message.info('添加成功')
                        that.getHotkey()
                    }) 
                }else{
                    editAllWordList({keywords:str1,id:this.groupId,groupName:that.formState.keyName}).then(res=>{
                        that.addVisible = false
                        message.info('修改成功')
                        that.getHotkey()
                    }) 
                }
                 
            })
            // let arr = []
            // this.dataSource.map((cur)=>{
            //     arr.push(cur.email)
            // })  
            // addHotkeyList({keywords:arr,receiveEmail:'2@qq.com',followPoint:3,groupName:'2'}).then(res=>{
            // })
        },
        async getHotkey(){
            let that = this
            await getIndexList({pageNo:1,pageSize:10}).then(res=>{
                that.hotWord = res.rows
            })
        },
        showModel(){

        },
        handleAdd(){
        const count = this.dataSource.length + 1
        const newData = {
            name: `${count}`,
            key:`${count}`,
            email: ``,
        };
        this.dataSource.push(newData);
        this.editableData[count] = {
            name: `${count}`,
            key:`${count}`,
            email: ``,
        };
        },
        onDelete(key){
            this.dataSource = this.dataSource.filter((item) => item.key !== key);
        },
        save(key){
            let that = this
            if(that.editableData[key].email==''){
            message.error('请输入关键词')
            return
            }
            // if(!(/^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/.test(that.editableData[key].email))){
            // message.error('邮箱格式不正确')
            // return
            // }
            let find = false;
            let arr = that.dataSource
            for     (let i = 0; i < arr.length; i++) {
                if (arr[i].email == that.editableData[key].email) { find = true; break;}
                if (find) break;
            }
            if(find){
            message.error('该邮箱已添加')
            return
            }
            Object.assign(
                that.dataSource.filter((item) => key === item.key)[0],
                that.editableData[key]
            );
            delete that.editableData[key];
        
        },
        edit(key){
        let that = this
        this.editableData[key] = cloneDeep(
            that.dataSource.filter((item) => key === item.key)[0]
        );
        },
        formatNum(n){
            if(n<0){
                return 0
            }
            let num = n.toString()
            let decimals = ''
                // 判断是否有小数
            num.indexOf('.') > -1 ? decimals = num.split('.')[1] : decimals
            let len = num.length
            if (len <= 3) {
                return num
            } else {
                let temp = ''
                let remainder = len % 3
                decimals ? temp = '.' + decimals : temp
                if (remainder > 0) { // 不是3的整数倍
                    return num.slice(0, remainder) + ',' + num.slice(remainder, len).match(/\d{3}/g).join(',') + temp
                } else { // 是3的整数倍
                    return num.slice(0, len).match(/\d{3}/g).join(',') + temp
                }
            }
        },
        addOne(){
            this.dataList = []
            this.editType = 0;
            this.formState.keyName = ''
            this.targetKeys = []
            this.addVisible = true
        },
        removeItem(ev,id){
            this.dataList.map((cur,index)=>{
                if(cur.id==id){
                    this.dataList.splice(index,1)
                }
            })
        },
        onSearch(){
            let canNext = false
            let that = this;
            if(that.searchVal==''){
                message.error('请输入关键词')
                return
            }
            that.defaultData.map((cur)=>{
                if(cur.title.toUpperCase()==that.searchVal.toUpperCase()){
                    that.searchVal = cur.title
                    canNext = true
                }
            })
            if(canNext){
                this.$router.push({name:'indexTool',query:{word:this.searchVal,type:0}})
            }else{
                this.$router.push({name:'indexNoData',query:{word:this.searchVal}})
            }
        },
        addItem(){
            this.dataList.push({id:-1,name:""})
        },
        add(id,name){
            let that = this;
            this.groupId = id;
            this.editType = 1;
            this.title = '修改组合'+name
            that.targetKeys = []
            getDetailByid(id).then(res=>{
                let data = res.data
                that.addVisible = true
                that.formState={
                    keyName:data.groupName,
                    // keyNum:data.followPoint,
                    // keyEmail:data.receiveEmail
                }
                let arr = []
                that.mockData.map((cur,index)=>{
                    data.keywords.split(',').forEach(function(_cur){
                        if(_cur==cur.title){
                             that.targetKeys.push(cur.key)
                        }
                    })
                })
                // that.targetKeys = data.keywords.split(',')
            })
        },
        delte(id){
            let that = this;
            Modal.confirm({
                title: '确认删除该组合?',
                onOk() {
                    removeHotKey(id).then(res=>{
                        that.getHotkey()
                        message.success('删除成功')
                    })
                },
                onCancel() {
                },
            });
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../assets/common/modal.scss';
.indexToolList{
    min-height: 100vh;
    padding-bottom: 10vh;
    background-color: #333333;
    background-image: url(../../assets/image/bg10.png);
    background-size: 100% 426px;
    background-repeat: no-repeat;
    background-position: 0 80px;
    font-family: 'NotoSansSC',sans-serif;
    position: relative;
    .hoverBottomWapper{
        width: 100%;
        padding-bottom: 20px;
        position: absolute;
        text-align: center;
        bottom: 0;
        background-color: #333;
        left: 0;
        .beian{
            position: relative;
            width:100%;
            // text-align:center;
            //  padding:0px 0 10px 0;
            width:fit-content;
            margin: 0 auto;
            display: block;
            text-align:center;
             p>a{
                color: rgb(147, 147, 147);
                 position: relative;
                padding-bottom: 5px;
                &::after{
                    content: "";
                    display: block;
                    height: auto;
                    border-bottom: 0!important;
                    background-image: linear-gradient(#00f000,#00f000);
                    text-decoration: none;
                    padding-bottom: 2px;
                    background-position: 0 100%;
                    background-repeat: no-repeat;
                    background-size: 0 2px;
                    transition: background-size .3s;
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    width: 100%;
                }
                &:hover{
                    color: #00F000;
                    // border-bottom: 1px solid #00F000;
                    // background-size: 100% 2px
                    &::after{
                        background-size: 100% 2px
                    }
                }
             }
        }
    }
    /deep/.ant-spin-blur{
        opacity: .75;
    }
    /deep/.ant-spin-nested-loading > div > .ant-spin{
        position: fixed;
        top: 50%;
        transform: translateY(-50%);
        z-index: 99;
    }
    /deep/.ant-spin-container::after{
        // background-color: transparent;
        display: none;
    }
    /deep/.ant-spin{
        color: #62f662;
        font-size: 30px;
        .ant-spin-dot-item{
            background-color: #62f662;
        }
    }
    .tool{
        padding: 100px 667px 0;
        margin: 0 auto;
        position: relative;
        .bg{
            position: absolute;
            top: -16px;
            left: 138px;
        }
        .btn-wrapper{
            display: flex;
            align-items: center;
            /deep/.ant-select{
                flex: 1;
                height: 50px;
                .ant-select-arrow{
                    display: none;
                }
                .ant-select-selection-placeholder{
                    height: 50px;
                    font-size: 24px;
                    line-height: 50px;
                }
                .ant-select-selector{
                    height: 50px;
                    font-size: 24px;
                    .ant-input{
                        height: 50px;
                        line-height: 50px;
                        padding: 0 11px;
                        font-size: 24px;
                        &:focus{
                            border-bottom: 2px solid #00f000;
                        }
                    }
                }
            }
            .search{
                width: 86px;
                height: 50px;
                font-size:24px;
                background-color: #333;
                border-color: #333;
                border-radius: 0;
            }
        }
        .title{
            font-size: 32px;
            line-height: 32px;
            height: 32px;
            color: #fff;
            margin-bottom: 40px;
            text-align: center;
        }
        /deep/.ant-input-search{
            width: 100%;
            .ant-input{
                height: 50px;
                font-size: 24px;
                &:focus{
                    border-bottom: 2px solid #00f000;
                }
            }
            .ant-input-search-button{
                height: 50px;
                font-size: 24px;
                background-color: #333333;
                border-color: #333333;
                border-radius: 0;
            }
        }
        .subTitle{
            font-size: 20px;
            color: #fff;
            margin-top: 40px;
        }
        .dataList{
            display: flex;
            margin-top: 18px;
            .list{
                width: 86px;
                height: 27px;
                background-color: #fff;
                margin-right: 20px;
                border-radius: 6px;
                text-align: center;
                line-height: 27px;
                color: #666666;
                font-size: 14px;
                cursor: pointer;
            }
        }
    }
    .hasData{
        padding: 0 152px;
        margin-top: 30px;
        /deep/.ant-table-row{
            .tip{
                width: 13px;
                margin-left: 5px;
            }
            td{
                &:nth-of-type(1){
                    position: relative;
                    cursor: pointer;
                    &::after{
                        content: "";
                        display: block;
                        height: auto;
                        border-bottom: 0!important;
                        background-image: linear-gradient(#00f000,#00f000);
                        text-decoration: none;
                        padding-bottom: 2px;
                        background-position: 0 100%;
                        background-repeat: no-repeat;
                        background-size: 0 2px;
                        transition: background-size .3s;
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        width: 100%;
                    }
                    &:hover{
                        color: #00F000;
                        // border-bottom: 1px solid #00F000;
                        // background-size: 100% 2px
                        &::after{
                            background-size: 100% 2px
                        }
                    }
                }
            }
        }
        /deep/.ant-pagination-item-active{
            // border-color: #fff;
            a{
                color: #333;
            }
        }
        /deep/.ant-pagination{
            width: 100%;
            background-color: #fff;
            padding: 10px;
            margin: 0 0 10px 0;
            text-align: right;
        }
        /deep/.ant-tabs-nav{
            padding-left: 40px;
        }
        /deep/.ant-tabs-bar{
            margin-bottom: 40px;
        }
        /deep/.ant-table-tbody > tr > td{
            border-color: #D9D9D9;
            border-right: 1px solid #D9D9D9;
        }
        /deep/.ant-tabs-bar{
            border-bottom: 0;
        }
   
        .link{
            color: #666666;
        }
        /deep/.ant-table-bordered .ant-table-tbody > tr > td{
            border-color: #D9D9D9;
            border-right: 1px solid #D9D9D9;
        }
        /deep/.ant-table-thead th{
            background-color: #000;
            border: 1px solid #D9D9D9!important;
            color: #fff;
            &:hover{
                background-color: #000;
            }
        }
        /deep/.ant-tabs-ink-bar{
            background-color: #00f000;
        }
        /deep/.ant-tabs-tab{
            font-size: 24px;
            color: #fff;
          &::after{
            content: "";
            display: block;
            height: auto;
            border-bottom: 0!important;
            background-image: linear-gradient(#00f000,#00f000);
           	text-decoration: none;
            padding-bottom: 2px;
            background-position: 0 100%;
            background-repeat: no-repeat;
            background-size: 0 2px;
            transition: background-size .3s;
            position: absolute;
            bottom: -49px;
            left: 0;
            width: 100%;
          }
          &:hover{
            color: #00F000;
            // border-bottom: 1px solid #00F000;
            // background-size: 100% 2px
            &::after{
            	background-size: 100% 2px
            }
          }
            &.ant-tabs-tab-active{
                color: #00f000;
            }
            
        }
        .listContain{
            padding-top: 40px;
            padding-bottom: 69px;
            .list{
                width: 512px;
                height: 320px;
                background-color: #fff;
                float: left;
                cursor: pointer;
                padding: 40px 0 60px 40px;
                margin-right: 20px;
                display: flex;
                position: relative;
                margin-bottom: 20px;
                .btnContain{
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    display: flex;
                    height: 60px;
                    cursor: pointer;
                    .edit{
                        flex: 1;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        // background-color: #00F000;
                        border-top: 1px solid #00F000;
                        background-color: #000;
                        font-size: 20px;
                        color: #fff;
                        transition: all .2s ease-in-out;
                        background: linear-gradient(45deg,#00f000 50%,#000 0);
                        background-size: 400% 100%;
                        background-position: 100% 100%;
                        transition: all .3s ease-out;
                        &:hover{
                            // background-color: #00F000;
                            // border-color: #00F000;
                            color: #000!important;
                            background-color: #fff!important;
                            border-color: #00f000!important;
                            background-position: 0 100%;
                            outline: none!important
                        }
                    }
                    .delete{
                        flex: 1;
                        background-color: #000;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        border-top: 1px solid #00F000;
                        border-left: 1px solid #00F000;
                        font-size: 20px;
                        color: #fff;
                        transition: all .2s ease-in-out;
                        background: linear-gradient(45deg,#00f000 50%,#000 0);
                        background-size: 400% 100%;
                        background-position: 100% 100%;
                        transition: all .3s ease-out;
                        &:hover{
                            // background-color: #00F000;
                            // border-color: #00F000;
                            color: #000!important;
                            background-color: #fff!important;
                            border-color: #00f000!important;
                            background-position: 0 100%;
                            outline: none!important
                        }
                    }
                }
                img{
                    width: 64px;
                    height: 64px;
                    margin-right: 25px;
                }
                .right{
                    flex: 1;
                    padding-top: 23px;
                    // margin-bottom: 60px;
                    .right1{
                        font-size: 20px;
                        color: #333;
                    }
                    .right2{
                        margin-top: 29px;
                        color: #a0a0a0;
                        font-size: 14px;
                        margin-bottom: 18px;
                    }
                    .right3{
                        // display: flex;
                        width: 100%;
                        .right-list{
                            min-width: 86px;
                            padding: 0 5px;
                            float: left;
                            height: 27px;
                            line-height: 27px;
                            border: 1px solid #C9C9C9;
                            font-size: 14px;
                            color: #666666;
                            margin-bottom: 10px;
                            text-align: center;
                            margin-right: 20px;
                            border-radius: 6px;
                        }
                    }
                }
                &:nth-of-type(3n){
                    margin-right: 0;
                }
                &.first{
                    padding:0;
                    height: 320px;
                    align-items: center;
                    justify-content: center;
                    color: #fff;
                    border: 1px dashed #FFFFFF;
                    background-color: transparent;
                    font-size: 24px;
                }
            }
        }
    }
}
</style>